import React, { useState } from "react";
import * as Sentry from "@sentry/react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useDispatch } from "react-redux";
import axios from "axios";
import baseUrl from "../../store/constants/baseUrl";
import ModalComponent from "../Modals/Modal";
import { userPaymentMethods } from "../../store/actions/paymentActions";
import { getUserProfile } from "../../store/actions/userProfileActions";

const CARD_OPTIONS = {
  iconStyle: "solid",
  showPostalCode: true,
  style: {
    base: {
      iconColor: "#c4f0ff",
      color: "black",
      fontWeight: "500",
      fontFamily: "Roboto,Open Sans,Segeo UI,sans-serif",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": { color: "black" },
      ":-placeholder": { color: "black" },
    },
    invalid: {
      iconColor: "#ffc7ee",
      color: "red",
    },
  },
};

const PaymentForm = ({
  userId,
  setAddStripe,
  setstripeLoader,
  submitWrapper,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const [modalFields, setModalFields] = useState({
    open: false,
    text: "",
    btnText1: "Ok",
    closeFunc: () => {
      setModalFields({ ...modalFields, open: false });
    },
  });

  const addStripeToUserAccount = async (userId, id, elements) => {
    try {
      const { data } = await axios.post(
        `${baseUrl}BookingsAPI/AddingStripeToUserProfile?userId=${userId}&token=${id}`
      );
      console.log("successful Payment with data", data.statusCode);
      if (data.statusCode === 200) {
        dispatch(userPaymentMethods(userId));
        try {
          const stored = localStorage.getItem("wemoovezUserProfile");
          if (stored) {
            const u = JSON.parse(stored);
            if (u?.email) dispatch(getUserProfile(u.email));
          }
        } catch (e) {
          Sentry.captureException(e);
          console.warn("Failed to refresh user profile after adding card", e);
        }
        setAddStripe(true);
        elements.getElement(CardElement).clear();
        setModalFields({
          ...modalFields,
          open: true,
          text: data?.message ?? "Card added successfully.",
        });
      }
    } catch (error) {
      if (setstripeLoader && setstripeLoader.set) setstripeLoader.set(false);
      Sentry.captureException(error);
      console.log(error);
      setModalFields({
        ...modalFields,
        open: true,
        text: error?.response?.data?.message ?? "Couldn't add card.",
      });
    }
  };
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const { error, token } = await stripe.createToken(
        elements.getElement(CardElement)
      );

      if (!error) {
        const { id } = token;
        if (setstripeLoader && setstripeLoader.set) setstripeLoader.set(true);
        await addStripeToUserAccount(userId, id, elements);
      } else {
        console.log("payment error", error.message);
        setAddStripe(false);
        if (setstripeLoader && setstripeLoader.set) setstripeLoader.set(false);
      }
    } catch (error) {
      if (setstripeLoader && setstripeLoader.set) setstripeLoader.set(false);
      Sentry.captureException(error);
      console.log(error);
    }
  };

  return (
    <div>
      <ModalComponent
        text={modalFields.text}
        openState={modalFields.open}
        closeFunction={() => {
          setModalFields({ ...modalFields, open: false });
        }}
        btnText1={modalFields.btnText1}
        btnClickFunc1={modalFields.closeFunc}
      />
      <form
        onSubmit={(e) =>
          submitWrapper ? submitWrapper(handleSubmit, e) : handleSubmit(e)
        }
        style={{
          display: "flex",
          justifyContent: "flex-end",
          flexWrap: "wrap",
        }}
      >
        <fieldset style={{ width: "100%" }}>
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <CardElement options={CARD_OPTIONS} />
          </div>
        </fieldset>

        <button
          type="submit"
          className="flex items-center justify-center bg-[#211F59] hover:bg-[#18164a] text-white px-6 py-2.5 rounded-lg font-semibold shadow-sm transition mt-5 ml-auto disabled:opacity-60 disabled:cursor-not-allowed"
          disabled={!!(setstripeLoader && setstripeLoader.loading)}
          style={{ minWidth: 120 }}
        >
          {setstripeLoader && setstripeLoader.loading ? (
            <span className="flex items-center justify-center">
              <svg className="animate-spin h-5 w-5 text-white mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
              </svg>
              Saving...
            </span>
          ) : (
            'Save Card'
          )}
        </button>
      </form>
    </div>
  );
};

export default PaymentForm;
